import styled from "styled-components";
import { COLORS } from "../../../assets/constants/styles";
import { media } from "../../../styles/mixins";

const getVariantStyles = (variant) => {
  const styles = {
    white: {
      default: {
        color: COLORS.black,
        backgroundColor: COLORS.white,
        borderColor: COLORS.lightViolet,
      },
      hover: {
        color: COLORS.violet,
        backgroundColor: COLORS.white,
        borderColor: COLORS.lightViolet,
      },
      disabled: {
        color: COLORS.white,
        backgroundColor: COLORS.lightGrey,
        borderColor: COLORS.lightGrey,
      },
    },
    red: {
      default: {
        color: COLORS.white,
        backgroundColor: COLORS.red,
        borderColor: COLORS.red,
      },
      hover: {
        color: COLORS.white,
        backgroundColor: COLORS.darkRed,
        borderColor: COLORS.darkRed,
      },
      disabled: {
        color: COLORS.white,
        backgroundColor: COLORS.lightGrey,
        borderColor: COLORS.lightGrey,
      },
    },
    green: {
      default: {
        color: COLORS.black,
        backgroundColor: COLORS.green,
        borderColor: COLORS.green,
      },
      hover: {
        color: COLORS.black,
        backgroundColor: COLORS.lightGreen,
        borderColor: COLORS.lightGreen,
      },
      disabled: {
        color: COLORS.white,
        backgroundColor: COLORS.lightGrey,
        borderColor: COLORS.lightGrey,
      },
    },
    transparent: {
      default: {
        color: COLORS.grey,
        backgroundColor: "transparent",
        borderColor: COLORS.white,
      },
      hover: {
        color: COLORS.violet,
        backgroundColor: "transparent",
        borderColor: COLORS.white,
      },
      disabled: {
        color: COLORS.lightGrey,
        backgroundColor: "transparent",
        borderColor: COLORS.lightGrey,
      },
    },
    violet: {
      default: {
        color: COLORS.white,
        backgroundColor: COLORS.violet,
        borderColor: COLORS.violet,
      },
      hover: {
        color: COLORS.white,
        backgroundColor: COLORS.darkViolet,
        borderColor: COLORS.darkViolet,
      },
      disabled: {
        color: COLORS.white,
        backgroundColor: COLORS.lightGrey,
        borderColor: COLORS.lightGrey,
      },
    },
  };

  return styles[variant] || styles.violet;
};

export const Button = ({
  text,
  onClick,
  variant = "violet",
  disabled,
  marginBottom = 0,
}) => {
  return (
    <ButtonContainer
      onClick={disabled ? undefined : onClick}
      $variant={variant}
      $marginBottom={marginBottom}
      $disabled={disabled}
    >
      <StyledButton>{text}</StyledButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}rem;
  padding: 0.594rem 1rem;
  border-radius: 0.75rem;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease-in-out;

  ${({ $variant, $disabled }) => {
    const styles = getVariantStyles($variant);
    const state = $disabled ? "disabled" : "default";

    return `
      color: ${styles[state].color};
      background-color: ${styles[state].backgroundColor};
      border: 1px solid ${styles[state].borderColor};
      
      ${
        !$disabled &&
        `
        &:hover {
          color: ${styles.hover.color};
          background-color: ${styles.hover.backgroundColor};
          border-color: ${styles.hover.borderColor};
        }
      `
      }
    `;
  }}

  ${media.tablet(`
    width: fit-content;
    padding: 0.75rem 1.5rem;
  `)}
`;

const StyledButton = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.313rem;
`;
